export default __webpack_public_path__ + "static/media/malovanie-tvar-vecer.d311ab0a.svg";